import { render, staticRenderFns } from "./UserTotal.vue?vue&type=template&id=d4445f20&scoped=true&"
import script from "./UserTotal.vue?vue&type=script&lang=ts&"
export * from "./UserTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4445f20",
  null
  
)

export default component.exports